import { Navigate, Route } from 'react-router';

/**
 * Hub pages that were folded into another screen. The old address still opens (bookmarks, alerts,
 * WhatsApp links) and lands on the screen that now does the job.
 */
export const RETIRED_HUB_ROUTES: Array<{ path: string; to: string }> = [
  // 27 Oct: Delivery follow-ups became Today's Follow-ups lane; since Today v2 (29 Oct) its Waiting on customer view.
  // Customer Care calls from Foundation.
  { path: 'delivery-follow-ups', to: '/today?view=waiting_customer' },
];

export const retiredHubRoutes = () =>
  RETIRED_HUB_ROUTES.map(({ path, to }) => (
    <Route key={path} path={path} element={<Navigate to={to} replace />} />
  ));
